export const dgFinancialTableHeaders = [
  "Facility Name",
  "Requested Amount",
  "Request Date",
  "Submitted By",
  "Status",
];

export const dgFinancialTableKey = [
  "facility_name",
  "requested_amount",
  "request_date",
  "submitted_by",
  "status",
];

export const getDGFinanceData = (_: any) => [
  {
    id: "1",
    facility_name: { value: "Kwara General Hospital", type: "string" },
    requested_amount: { value: "1500000", type: "string" },
    current_balance: { value: "500000", type: "string" },
    request_date: { value: "2025-07-01", type: "string" },
    submitted_by: { value: "Babatunde Salami", type: "string" },
    status: { value: "approved", type: "string" },
    justification: {
      value: "Replenishment of essential malaria and antibiotic drugs.",
      type: "string",
    },
    expected_disbursement_date: { value: "2025-07-18", type: "string" },
  },
  {
    id: "2",
    facility_name: { value: "Ilorin East PHC", type: "string" },
    requested_amount: { value: "850000", type: "string" },
    current_balance: { value: "250000", type: "string" },
    request_date: { value: "2025-06-25", type: "string" },
    submitted_by: { value: "Ngozi Eze", type: "string" },
    status: { value: "pending", type: "string" },
    justification: {
      value: "Stocking new delivery kits and obstetric supplies.",
      type: "string",
    },
    expected_disbursement_date: { value: "", type: "string" },
  },
  {
    id: "3",
    facility_name: { value: "Offa Specialist Hospital", type: "string" },
    requested_amount: { value: "2000000", type: "string" },
    current_balance: { value: "900000", type: "string" },
    request_date: { value: "2025-06-30", type: "string" },
    submitted_by: { value: "Chinedu Okoro", type: "string" },
    status: { value: "rejected", type: "string" },
    justification: {
      value: "Procurement of equipment for emergency ward expansion.",
      type: "string",
    },
    expected_disbursement_date: { value: "", type: "string" },
  },
  {
    id: "4",
    facility_name: { value: "Asa Local PHC", type: "string" },
    requested_amount: { value: "500000", type: "string" },
    current_balance: { value: "150000", type: "string" },
    request_date: { value: "2025-07-05", type: "string" },
    submitted_by: { value: "Aisha Mohammed", type: "string" },
    status: { value: "approved", type: "string" },
    justification: {
      value: "Restocking of routine immunization vaccines.",
      type: "string",
    },
    expected_disbursement_date: { value: "2025-07-20", type: "string" },
  },
  {
    id: "5",
    facility_name: { value: "Lafiagi General Hospital", type: "string" },
    requested_amount: { value: "1200000", type: "string" },
    current_balance: { value: "430000", type: "string" },
    request_date: { value: "2025-06-28", type: "string" },
    submitted_by: { value: "Ibrahim Yusuf", type: "string" },
    status: { value: "pending", type: "string" },
    justification: {
      value: "Critical repair of cold chain equipment and lab tools.",
      type: "string",
    },
    expected_disbursement_date: { value: "", type: "string" },
  },
  {
    id: "6",
    facility_name: { value: "Patigi PHC", type: "string" },
    requested_amount: { value: "400000", type: "string" },
    current_balance: { value: "80000", type: "string" },
    request_date: { value: "2025-07-03", type: "string" },
    submitted_by: { value: "Yetunde Afolabi", type: "string" },
    status: { value: "approved", type: "string" },
    justification: {
      value: "Purchase of antimalarial medication and wound care kits.",
      type: "string",
    },
    expected_disbursement_date: { value: "2025-07-19", type: "string" },
  },
  {
    id: "7",
    facility_name: { value: "Oyun Health Centre", type: "string" },
    requested_amount: { value: "675000", type: "string" },
    current_balance: { value: "120000", type: "string" },
    request_date: { value: "2025-06-22", type: "string" },
    submitted_by: { value: "Tunde Balogun", type: "string" },
    status: { value: "rejected", type: "string" },
    justification: {
      value: "Emergency replenishment due to post-flood losses.",
      type: "string",
    },
    expected_disbursement_date: { value: "", type: "string" },
  },
  {
    id: "8",
    facility_name: { value: "Kaiama General Hospital", type: "string" },
    requested_amount: { value: "980000", type: "string" },
    current_balance: { value: "260000", type: "string" },
    request_date: { value: "2025-07-02", type: "string" },
    submitted_by: { value: "Fatima Bello", type: "string" },
    status: { value: "pending", type: "string" },
    justification: {
      value: "For lab reagents and emergency C-section supplies.",
      type: "string",
    },
    expected_disbursement_date: { value: "", type: "string" },
  },
  {
    id: "9",
    facility_name: { value: "Baruten Clinic", type: "string" },
    requested_amount: { value: "300000", type: "string" },
    current_balance: { value: "100000", type: "string" },
    request_date: { value: "2025-06-20", type: "string" },
    submitted_by: { value: "Uche Nwosu", type: "string" },
    status: { value: "approved", type: "string" },
    justification: {
      value: "Urgent funding for restocking diabetic medication.",
      type: "string",
    },
    expected_disbursement_date: { value: "2025-07-17", type: "string" },
  },
  {
    id: "10",
    facility_name: { value: "Edu General Hospital", type: "string" },
    requested_amount: { value: "1750000", type: "string" },
    current_balance: { value: "850000", type: "string" },
    request_date: { value: "2025-06-26", type: "string" },
    submitted_by: { value: "Halima Tijani", type: "string" },
    status: { value: "rejected", type: "string" },
    justification: {
      value: "Procurement of additional delivery beds and monitors.",
      type: "string",
    },
    expected_disbursement_date: { value: "", type: "string" },
  },
];

export const getRequestDetails = (data: any) => {
  const details = {
    facility_name: data?.facility_name?.value,
    submitted_by: data?.submitted_by?.value,
    amount_requested: data?.requested_amount?.value,
    status: data?.status?.value,
    request_date: data?.request_date?.value,
    justification: data?.justification?.value,
    current_balance: data?.current_balance?.value,
    expected_disbursement_date: data?.expected_disbursement_date?.value,
  };
  return details;
};
